import React from 'react';
import {connect} from "react-redux";
import BsPanelLoader from "components/panel/loader/BsPanelLoader";
import BsPanelHeader from "components/panel/header/BsPanelHeader";
import BsDataTable from "components/data-table/BsDataTable";
import BsPanelTitle from "components/panel/header/BsPanelTitle";
import BsTabPanel from "components/panel/BsTabPanel";
import BACK_OFFICE_USER_SYSTEMS_TABLE from "./back-office-user-systems-table";
import {loadSystemsByAdminId} from "core/actions/system-actions";
import Button from "@material-ui/core/Button";
import {Trans} from "react-i18next";
import ConfirmationModel from "components/model/ConfirmationModel";
import {changeAdminUserStatus} from "core/actions/admin-actions";

const queryString = require('query-string');

class BackOfficeUserSystemsTab extends React.Component {

  constructor(props) {
    super(props);
    const query = queryString.parse(this.props.location.search);
    this.state = {
      sort: query.sort,
      direction: query.direction,
      confirmationWindow: {
        open: false,
        message: ''
      },
      event: () => {
      }
    };

    this.config = {
      ...BACK_OFFICE_USER_SYSTEMS_TABLE
    }
    for (let i = 0; i < this.config.columns.length; i++) {
      if (this.config.columns[i].field === 'changeStatus') {
        this.config.columns[i].getValue = (raw) => {
          if (raw.userStatus === 'ACTIVE') {
            return <Button variant="contained" color="primary" type="button"
                           onClick={() => this.onInactive(raw)}>
              <Trans i18nKey="admin_info.inactive_btn"/>
            </Button>
          } else if (raw.userStatus === 'INACTIVE') {
            return <Button variant="contained" color="primary" type="button"
                           onClick={() => this.onActive(raw)}>
              <Trans i18nKey="admin_info.active_btn"/>
            </Button>
          } else {
            return null;
          }
        };
      }
    }

    this.onLoadData(query);
  }

  onInactive = (row) => {
    this.setState({
      ...this.state,
      confirmationWindow: {
        open: true,
        message: 'admin_info.inactive_admin_confirmation_message'
      },
      event: () => this.inactiveAdmin(row)
    })
  }

  onActive = (row) => {
    this.setState({
      ...this.state,
      confirmationWindow: {
        open: true,
        message: 'admin_info.active_admin_confirmation_message'
      },
      event: () => this.activeAdmin(row)
    })
  }

  inactiveAdmin(row) {
    this.closeConfirmationModel()
    this.props.changeStatus(row.id, this.props.match.params.userId, 'INACTIVE')
    row.userStatus = 'INACTIVE';
  }

  activeAdmin(row) {
    this.closeConfirmationModel()
    console.log(row)
    this.props.changeStatus(row.id, this.props.match.params.userId, 'ACTIVE')
    row.userStatus = 'ACTIVE';
  }

  closeConfirmationModel() {
    this.setState({
      ...this.state,
      confirmationWindow: {
        ...this.state.confirmationWindow,
        open: false
      }
    });
  }

  onRequestSort = (params) => {
    this.setState({
      sort: params.sort,
      direction: params.direction
    });
    this.onLoadData(params);
  }

  onLoadData = (query) => {
    this.props.loadSystemsByAdminId(this.props.match.params.userId, this.prepareQuery(query));
  }

  onRowClick = (row) => {
  }

  prepareQuery = (query) => {
    if (query.sort) {
      query.sort = query.sort + ',' + query.direction;
    }

    return query
  }

  render() {
    return (
        <BsTabPanel>
          <BsPanelLoader show={this.props.loading}/>
          <BsPanelHeader>
            <BsPanelTitle/>
          </BsPanelHeader>

          <ConfirmationModel
            open={this.state.confirmationWindow.open}
            message={this.state.confirmationWindow.message}
            handleClose={this.closeConfirmationModel.bind(this)}
            handleApply={this.state.event.bind(this)}
          />

          <BsDataTable location={this.props.location}
                       history={this.props.history}
                       order={this.state.direction}
                       orderBy={this.state.sort}
                       settings={this.config}
                       content={this.props.systems}
                       onRowClick={this.onRowClick}
                       onChangePage={this.onLoadData}
                       onChangeSize={this.onLoadData}
                       onRequestSort={this.onRequestSort}/>
        </BsTabPanel>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    systems: state.system.userSystems,
    loading: state.system.loadingSystems,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadSystemsByAdminId: (adminId, query) => {
      dispatch(loadSystemsByAdminId(adminId, query));
    },
    changeStatus: (systemId, userId, status) => {
      dispatch(changeAdminUserStatus(systemId, userId, status));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BackOfficeUserSystemsTab);
